module.exports = __webpack_public_path__ + "img/logo.cdaed7f9.png";